
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/auth/login",
      function () {
        return require("private-next-pages/auth/login/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/auth/login"])
      });
    }
  